import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { l, Loader } from '@manychat/manyui'

import NextStepPane from 'common/builder/components/builder/NextStepPane'
import { NodeType } from 'common/builder/constants/NodeType'
import { convertToVariable } from 'common/builder/constants/PhoneInputType'
import {
  NextStepType,
  NextStepTypeIcons,
  NextStepTypeNames,
  NextStepTypeColors,
  NextStepCrossChannelConfig,
} from 'common/builder/models/Source/constants'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import { isNextStepTypeUrl } from 'common/builder/utils/isNextStepTypeUrl'

const NextStepPaneController = connect((state, props) => {
  const { builderId, targetId, type, source, disableReset, className } = props
  const target = entitySelectors.getNodeById(state, builderId, targetId)
  const node = entitySelectors.getParentNode(state, builderId, source?.id)
  const flow = source && state.flow.byId[source.flowId]

  let caption = null
  const clickable = ![
    NextStepType.SHARE,
    NextStepType.URL,
    NextStepType.CTA_URL,
    NextStepType.CALL,
    NextStepType.FLOW,
  ].includes(type)

  if (type === NextStepType.CALL) {
    caption = convertToVariable(source.phone) || l.translate('Enter number below')
  } else if (isNextStepTypeUrl(type)) {
    caption = source.url || l.translate('Enter url below')
  } else if (type === NextStepType.GOTO) {
    caption = (flow && flow.name) || l.translate('Select Automation to start')
  } else if (type === NextStepType.FLOW) {
    caption = (flow && flow.name) || l.translate('Select Automation')
  } else if (type === NextStepType.AI_AGENT) {
    caption = l.translate('Let AI handle conversations')
  } else if (includes(NodeType, type)) {
    caption = get(target, 'caption', null)
  }

  let color = null
  let icon = null

  if (type === NextStepType.CROSS_CHANNEL_CONTENT) {
    color = NextStepCrossChannelConfig[source.channel].color
    icon = NextStepCrossChannelConfig[source.channel].icon
  } else {
    color = NextStepTypeColors[type]
    icon = NextStepTypeIcons[type]
  }

  return {
    color,
    icon,
    title: l.getString(NextStepTypeNames[type]),
    caption,
    target,
    targetId,
    targetType: get(target, 'nodeType', null),
    clickable,
    disableReset:
      disableReset || (node?.whatsAppNodeType === 'template' && type === NextStepType.URL),
    className,
  }
})(({ targetId, target, ...props }) =>
  targetId && !target ? <Loader size={50} /> : <NextStepPane {...props} />,
)

NextStepPaneController.propTypes = {
  builderId: PropTypes.string,
  targetId: PropTypes.any,
  type: PropTypes.string,
  onOpen: PropTypes.func,
  onReset: PropTypes.func,
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
  disableReset: PropTypes.bool,
  className: PropTypes.string,
}

export default NextStepPaneController
